import type { AnyAction, Reducer } from 'redux';

import type { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import type { FeatureRolloutConfig } from './types';

export type SessionAction = SessionConfigureAction;

const initialState: FeatureRolloutConfig = {
  enableFlightControlPanel: false,
};

const reducer: Reducer<FeatureRolloutConfig, SessionAction | AnyAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.featureRollout;
    default:
      return state;
  }
};

export default reducer;
